import React from "react";

import { styles } from "@common/styles";

const headerWrapperStyle = {
  ...styles.headerWrapper,
  "@media (minWidth: 600px)": { flexDirection: "row" }
};
const pageHeaderWithExtrasStyle = {
  ...styles.pageHeaderWithExtrasContainer,
  "@media (minWidth: 1024px)": { marginBottom: "33px" }
};

const header = ({ navigateBack }) => (
  <div className="headerWrapper" style={headerWrapperStyle as any}>
    <div
      className="pageHeaderWithExtras"
      style={pageHeaderWithExtrasStyle as any}
    >
      Administrer bruker
    </div>
    <div className="extrasContainer" style={styles.extrasContainer as any}>
      <div
        className="link"
        style={styles.listLinkStyle as any}
        onClick={navigateBack}
        title="Tilbake til alle brukere"
      >
        Tilbake til alle brukere
      </div>
    </div>
  </div>
);

export default header;
